<script setup lang="ts">
import RoomieIcon from '@lahaus-roomie/roomie/src/components/RoomieIcon/index.vue'
import SearchIcon from '@lahaus-roomie/roomie/src/assets/icons/v2/search.svg'
import RoomieButton from '@lahaus-roomie/roomie/src/components/RoomieButton/index.vue'
import { ref } from 'vue'
import LocationAutocomplete from '@/components/BrandedV2/LocationAutocomplete/index.vue'
import useRealEstateSearch from '@/components/BrandedV2/RealEstateSearch/use-search'
import type { SuggestionClient } from '@/services/listingDataService/types/suggestion'

const { locale } = useI18n()
const { $useLhId } = useNuxtApp()
const suggestion = ref<SuggestionClient.Suggestion>({})

const emit = defineEmits(['filters-change', 'residential-complex-selected'])

const {
  searchTerm,
  onSubmit,
  suggestionSelected,
  setNeighborhoodsBySuggestion
} = useRealEstateSearch('/venta/propiedades', emit)

const onSuggestionSelected = (value: SuggestionClient.Suggestion) => {
  suggestion.value = value
  suggestionSelected(value)
}

const onHandleSubmit = () => {
  setNeighborhoodsBySuggestion(suggestion.value)
  onSubmit()
  searchTerm.value = ''
}

</script>

<script lang="ts">
export default {
  name: 'RealEstateSearchNavBar'
}
</script>

<template>
  <div class="real-estate-search-nav-bar">
    <form
      class="w-full flex flex-row gap-0 items-center"
      @submit.prevent="onHandleSubmit">
      <LocationAutocomplete
        v-model="searchTerm"
        class="real-estate-search-nav-bar__autocomplete"
        placeholder="Busca por ciudad, zona o nombre del proyecto"
        :country-code="locale"
        container-class="w-full flex flex-row gap-0"
        input-container-class="w-full"
        :min-chars="3"
        :data-attributes="{ dataLh: { P: 'venta', Z: 'encabezado' } }"
        @select="onSuggestionSelected">
        <RoomieButton
          id="real-estate-search-nav-bar"
          type="submit"
          class="real-estate-search-nav-bar__filter-button"
          :data-lh-id="$useLhId({ P: 'srp', Z: 'encabezado', A: 'buscar', C: 'lupa' })"
          variant="accent">
          <RoomieIcon custom-styles="block w-24 h-24 text-pine-600">
            <SearchIcon />
          </RoomieIcon>
        </RoomieButton>
      </LocationAutocomplete>
    </form>
  </div>
</template>

<style src="./_index.scss" lang="scss"></style>
